import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type ModalPortalShellProps = {
  open?: boolean;
  children: ReactNode;
  /** Classes do painel (largura, etc.). */
  panelClassName?: string;
  /** Classes do overlay (z-index, etc.). */
  overlayClassName?: string;
};

/**
 * Overlay em portal no document.body, limitado à viewport, com scroll interno
 * quando o conteúdo ultrapassa a altura disponível.
 */
export function ModalPortalShell({
  open = true,
  children,
  panelClassName = 'erp-card max-w-lg shadow-xl',
  overlayClassName = 'z-[100]',
}: ModalPortalShellProps) {
  if (!open) return null;

  return createPortal(
    <div
      className={`fixed inset-0 flex items-start justify-center overflow-y-auto bg-black/40 p-4 sm:items-center ${overlayClassName}`}
    >
      <div
        className={`my-auto flex max-h-[calc(100dvh-2rem)] w-full flex-col overflow-hidden ${panelClassName}`}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
